import { jsx } from "react/jsx-runtime";
import { Box } from "braid-design-system";
import { layout } from "../HirerBalancePresentation.css.mjs";
const HirerBalanceLayout = ({ children }) => /* @__PURE__ */ jsx(
  Box,
  {
    className: layout,
    padding: "large",
    borderRadius: "large",
    background: "formAccentSoft",
    children
  }
);
export {
  HirerBalanceLayout
};
